import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures each navigation starts at the top of the page.
 * This is especially important for long pages (FAQ, legal pages, etc.).
 */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // If there's a hash, let the browser handle anchor scrolling.
    if (location.hash) return;

    // Force immediate scroll to top on route changes.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
